import { DownloadOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import { FC } from 'react';
import { IReportType } from '../../../../types/reports';
import styles from '../Reports.module.scss';

interface ReportNavigationProps {
  reportItem: IReportType;
  isActive: boolean;
  handleReportTypeChanged: (report: IReportType) => void;
  showIcon?: boolean;
}

export const ReportNavigationButton: FC<ReportNavigationProps> = ({
  reportItem,
  isActive,
  handleReportTypeChanged,
  showIcon,
}) => {
  const id = reportItem.id.replace(/\s+/g, '');

  return (
    <div
      role='button'
      key={id}
      id={`Reports-${id}-Navigation_Button`}
      className={clsx(
        styles.container,
        isActive && styles.containerActive,
        reportItem.disabled && styles.containerDisabled
      )}
      onClick={() =>
        !reportItem.disabled && handleReportTypeChanged(reportItem)
      }
    >
      <span
        className={clsx(
          styles.text,
          isActive && styles.textActive,
          reportItem.disabled && styles.textDisabled
        )}
      >
        {reportItem.name}
      </span>
      {reportItem?.additionalText && (
        <span className={styles.additionalText}>
          {reportItem?.additionalText}
        </span>
      )}
      {showIcon && <DownloadOutlined className={styles.buttonIcon} />}
    </div>
  );
};
